export const KeyMode = {
  light: 'light',
  dark: 'dark',
};
